import { render } from "./CategoryItem.vue?vue&type=template&id=9471eb1c&ts=true&lang=pug"
import script from "./CategoryItem.vue?vue&type=script&lang=ts"
export * from "./CategoryItem.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__